import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';
import { Heading } from '@gitbook/spine-react';

import { useNavigation } from '../../../navigation';
import { apiClient } from '../../../state';
import { SiteQuickActionCard, SiteQuickActionCardIcon } from '../../Site';
import type { SpaceCreationOnCreateSpace } from './types';

interface GitSyncCardProps {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function GitSyncCard(props: GitSyncCardProps) {
    const { organizationId, onCreateSpace } = props;
    const { navigate } = useNavigation();
    return (
        <SiteQuickActionCard
            onPress={async () => {
                onCreateSpace(
                    async ({ collectionId }) => {
                        const { data: space } = await apiClient.spaces.createSpace(organizationId, {
                            parent: collectionId,
                        });
                        analytics.logEvent(
                            analytics.createSpaceEvent(space, {
                                type: 'space_create',
                                source: 'gitsync',
                            })
                        );
                        return space;
                    },
                    (space) => {
                        navigate({
                            screen: {
                                type: 'space',
                                organization: organizationId,
                                space: space.id,
                                sideSheet: {
                                    type: 'gitsync-setup',
                                },
                            },
                        });
                    }
                );
            }}
        >
            <SiteQuickActionCardIcon>
                <Icon.GitHub />
            </SiteQuickActionCardIcon>
            <Heading>Sync with Git</Heading>
        </SiteQuickActionCard>
    );
}
